import React, { Component } from 'react';
import './Menu.css';
import './IconButton.css';
import './Filters.css';
import MenuType from '../enums/MenuType';
import IconButton from './IconButton';
import HashSource from '../core/HashSource';
import UnitMarkerKey from './UnitMarkerKey';
import ClickedOffManager from '../ui_core/ClickedOffManager';
import { faWalking, faMapMarker, faPoundSign, faHome, faBed, faBackspace} from '@fortawesome/free-solid-svg-icons';
import SubMenuHeader from './SubMenuHeader';
import Urls from '../urls/Urls';
import AssetsManager from  '../assets_management/AssetsManager';
import Tutorials from '../tutorials/Tutorials';
import TutorialMessage from '../tutorials/TutorialMessage';
export default class FiltersButtons extends Component {
	constructor(props){
		super(props)
		const {clickClear, clickShowForSale, getConfiguration, nextKey, singleRow, iMenuManager} = props;
		this._getConfiguration = getConfiguration;
		this._clickClear = clickClear;
		this._clickShowForSale = clickShowForSale;
		this._singleRow = singleRow;
		this._uniqueKey = 0;
		this._buttonStatusRef = React.createRef();
		this._nextKey = nextKey?nextKey:()=>String(this._uniqueKey ++);
		this._handleClickFeatures=this._handleClickFeatures.bind(this);
		this._handleClickPlot=this._handleClickPlot.bind(this);
		this._handleClickShowForSale=this._handleClickShowForSale.bind(this);
		this._handleClickStatus=this._handleClickStatus.bind(this);
		this._handleClickAvailablePrices=this._handleClickAvailablePrices.bind(this);
		this._handleClickBedrooms=this._handleClickBedrooms.bind(this);
		this._handleClickHouseType=this._handleClickHouseType.bind(this);
		this._handleClickClear=this._handleClickClear.bind(this);
		this._iMenuManager  = iMenuManager;
		this.load = this.load.bind(this);
		this.state = {siteJson:null};
		Tutorials.addEventListener('update', this._updateTutorialMessages);
	}
	_updateTutorialMessages(){
		this._tutorialMessageStatus?.dispose();
		setTimeout(()=>{
			this._tutorialMessageStatus?.dispose();
			if(Tutorials.showing&&this._isShowing&&!Tutorials.hasClickedFilterStatus){
				this._tutorialMessageStatus = new TutorialMessage({
					message:'Click to filter on availability', elementOn:this._buttonStatusRef.current._elementRef.current,
					className:'tutorial-message-status',							
					hasClose:true, callbackClose:()=>{
						Tutorials.showing = false;
						this._tutorialMessageStatus.dispose();
					},
					fixInPlace:true
				});
				Tutorials.addShowingTutorialMessage(this._tutorialMessageStatus);
			}
		});
	}
	set isShowing(value){
		this._isShowing = value;
		this._updateTutorialMessages();
	}
	load({siteJson}){
		this.setState({siteJson});
	}
	setIMenuManager(value){
		this._iMenuManager = value;
	}
	_handleClickPlot(){
		this._iMenuManager.showMenuByType(MenuType.PLOT_SEARCH);
	}
	_handleClickShowForSale(){
		this._clickShowForSale();
	}
	_handleClickStatus(){
		this._iMenuManager.showMenuByType(MenuType.STATUS_FILTER);
	}
	_handleClickAvailablePrices(){
		this._iMenuManager.showMenuByType(MenuType.AVAILABLE_PRICES_FILTER);
	}
	_handleClickBedrooms(){
		this._iMenuManager.showMenuByType(MenuType.BEDROOMS_FILTER);
	}
	_handleClickHouseType(){
		this._iMenuManager.showMenuByType(MenuType.HOUSE_TYPE_FILTER);
	}
	_handleClickClear(){
		this._clickClear();
	}
	_handleClickFeatures(){
		this._iMenuManager.showMenuByType(MenuType.FEATURES_FILTER);
	}
	render() {
		this._updateTutorialMessages();
		const configuration = this._getConfiguration();
		const rows =[];
		let uniqueKey = 0;
		if(configuration.showShowForSaleButton){
			rows.push((
				<div className="row" key={this._nextKey()}><IconButton faIcon={faPoundSign} text="Show for sale" onClick={this._handleClickShowForSale}></IconButton>
				</div>));
		}
		const featuresEnabled = configuration.featuresEnabled;
		const features = !featuresEnabled
			?null
			:(<IconButton className="filter-button" imgUrl={Urls.assets+'icons/UI_Button_Features.png'}
				text="Features" onClick={this._handleClickFeatures}></IconButton>
			);
		const clearButton = (<IconButton className="filter-button" imgUrl={Urls.assets+'icons/UI_Button_Filter_Clear.png'} 
			text="Clear" onClick={this._handleClickClear}></IconButton>);
		const iconButtonStatus = (
					<IconButton className="filter-button" ref={this._buttonStatusRef} imgUrl={Urls.assets+'icons/UI_Button_Filter_Status.png'} text="Availability" onClick={this._handleClickStatus}></IconButton>);
		const iconButtonPrice = (
		<IconButton className="filter-button" imgUrl={Urls.assets+'icons/UI_Button_Filter_Price.png'} text="Available prices" onClick={this._handleClickAvailablePrices}></IconButton>);
		const iconButtonBedrooms = 
					<IconButton className="filter-button" imgUrl={Urls.assets+'icons/UI_Button_Filter_Bedrooms.png'} text="Bedrooms" onClick={this._handleClickBedrooms}></IconButton>;
					const iconButtonHouseType = (<IconButton className="filter-button" imgUrl={Urls.assets+'icons/UI_Button_Filter_HouseType.png'} key={HashSource.next()} text={this.state.siteJson?.allUnitsHaveMultiplePlots?"Apartment Type":"House type"} onClick={this._handleClickHouseType}></IconButton>
					);
		const iconButtonPlot = (
					<IconButton className="filter-button" imgUrl={Urls.assets+'icons/UI_Button_Filter_Plot.png'} text="Plot" onClick={this._handleClickPlot}></IconButton>);
		if(this._singleRow){
			
				return [iconButtonStatus,
					iconButtonPrice,
					iconButtonBedrooms,
					iconButtonHouseType,
					iconButtonPlot,
					featuresEnabled?features:clearButton
					];
		}
		else{rows.push((
				<div className="row" key={this._nextKey()}>
					{iconButtonStatus}
					{iconButtonPrice}
					{iconButtonBedrooms}
				</div>));
		rows.push((<div className="row" key={this._nextKey()}>
					{iconButtonHouseType}
					{iconButtonPlot}
					{featuresEnabled?features:clearButton}
				</div>));
		if(featuresEnabled){
			rows.push((<div className="row" key={this._nextKey()}>
				{clearButton}
			</div>));
		}
		}
		return rows;
	}
}